var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheTopBar',_vm._g({attrs:{"controls":_vm.controls,"menu-offset":_vm.menuOffset,"with-fullscreen-button":""}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }